import React from "react";
import { Routes, Route } from "react-router-dom";
import ForgotPassword from "../pages/ForgotPassword";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import CreatePassword from "../pages/CreatePassword";
import ResetPassword from "../pages/ResetPassword";
import DefaultLayout from "../components/DefaultLayout";
import CustomerForm from "../customerQRForm/CustomerForm";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../components/ErrorFallback";
import CreateEmpPassword from "../pages/CreateEmpPassword";
import ResetEmpPassword from "../salesperson/ResetEmpPassword";
import { Spin } from "antd";
import { Suspense } from "react";
import { LANDING_ROUTES } from "../pages/landingpages/navConfig";
const AppPrivacyPolicy = React.lazy(() => import("../pages/AppPrivacyPolicy"));
const RouteErrorFallback = ({ error }) => <ErrorFallback error={error} />;
const Routing = () => {
  return (
    <Suspense fallback={<Spin size="large" />}>
      <Routes>
        <Route
          path="/"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ProtectedRoute route="LandingPage" />
            </ErrorBoundary>
          }
        />
        {/* Public landing tabs. Each one renders the same LandingPage; the
            component reads the pathname to decide which section to show and
            which nav tab to highlight. "/" is declared above. */}
        {LANDING_ROUTES.filter((item) => item.path !== "/").map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={
              <ErrorBoundary
                FallbackComponent={RouteErrorFallback}
              >
                <ProtectedRoute route="LandingPage" />
              </ErrorBoundary>
            }
          />
        ))}
        <Route
          path="/sign-in"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ProtectedRoute route="SignIn" />
            </ErrorBoundary>
          }
        />
        <Route
          path="/emp-login"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ProtectedRoute route="EmpLogin" />
            </ErrorBoundary>
          }
        />
        <Route
          path="/create-password"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <CreatePassword />
            </ErrorBoundary>
          }
        />
        <Route
          path="/create-emp-password"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <CreateEmpPassword />
            </ErrorBoundary>
          }
        />
        <Route
          path="/reset-password"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ResetPassword />
            </ErrorBoundary>
          }
        />
        <Route
          path="/reset-emp-password"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ResetEmpPassword />
            </ErrorBoundary>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <ForgotPassword />
            </ErrorBoundary>
          }
        />
        <Route
          path="/customer-form"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <CustomerForm />
            </ErrorBoundary>
          }
        />
        <Route
          path="/app-privacy-policy"
          element={
            <ErrorBoundary
              FallbackComponent={RouteErrorFallback}
            >
              <AppPrivacyPolicy />
            </ErrorBoundary>
          }
        />
        <Route
          path="/agent-dashboard"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AgentDashboard" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/merchant-dashboard"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="MerchantDashboard" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="EmployeeDashboard" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/dashboard"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="Dashboard" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/employeeManagement/add-employee"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddEmployee" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/salesperson-setup"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="SalespersonSetup" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/scan-data/subscription"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ScanDataSubscription" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/scan-data/items"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ScanDataItems" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/deliveryperson-setup"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="DeliverypersonSetup" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/employeeManagement/add-employee-role"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddEmpRole" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/employee-permission"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="EmployeePermission" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/add-pos"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddPos" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/pos-log"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PosLogViewer" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/all-pinpad-list"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AllPinPadList" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/upload-pos-apk"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="UploadPosApk" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/pos-customize"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PosCustomize" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/ip-config"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="IpConfiguration" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/registeredPos-list"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PosListStoreWise" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/add-flag"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddFlag" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/add-store"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddStore" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/add-department"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddDepartment" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/add-product"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="Products" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/barcode-scale"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="BarcodeScale" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/add-promotion"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PromotionManagement" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/tax-mangement"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="TaxMangement" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/card-fee-setup"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CardFeeSetup" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/mass-product-update"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="MassProductUpdate" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/payout"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="Payout" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/purchase-order"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PurchaseOrder" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/purchase-order/order-history"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="OrderHistory" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/purchase-order/preview-order"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PreviewOrder" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/storemanagement/store-setting"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="StoreSetting" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/product"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ProductReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/pay-roll"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="PayRollReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/productivity"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ProductivityReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/shift-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ShiftReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/sales-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="SalesReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/department"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="DepartmentReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/tax-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="TaxReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/pay-roll"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="Reports" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/clock-in-out"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ClockInOutReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/clock-in-out/details"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ClockInOutDetailsByDay" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/clock-in-out/byDateRange"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ClockInOutByRange" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/transaction"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="TransactionReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/cashdrop"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CashDropReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/transaction/details/:id/:orderStatus"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="TransactionDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/profit-report/details/:id/:orderNumber"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ProfitByOrder" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/batch-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="BatchReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/batch-report/details/:id"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="BatchDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/cona-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ConaReport" />
                </ErrorBoundary>
              }
            />
          }
        />{" "}
        <Route
          path="/report/profit-report"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ProfitReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/emp-productivity"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ProductivityReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/report/emp-commission"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CommissionReport" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/user-management"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="UserManagement" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/customer-engagement"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CustomerEngagement" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/assigned-customers"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AssignedCustomers" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/assigned-customers/history/:id"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AssignedCustomerDetail" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/assigned-customers/history/order-details/:id"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AssignedCustomerTransactionDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/salesperson-order-history"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="SalespersonOrderHistory" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/orders"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="Orders" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/orders/WMSOrderDetails/:id/:orderStatus"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="WMSOrderDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/orders/add-to-cart"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddtoCart" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/orders/add-to-cart/item-detail"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ItemDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/orders/add-to-cart/checkout"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CheckOut" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/edit-customer-order/add-item"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="AddItemIntoOrder" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/edit-customer-order"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="EditCustomerOrder" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/manage-agent"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ManageAgent" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/manage-merchant"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ManageMerchant" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/store-list"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="StoreList" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/usersetting"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="UserSetting" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/contact-us"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="ContactUs" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/customer-engagement/customer-detail/:id"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CustomerDetail" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/customer-engagement/customer-detail/order-detail/:id"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CustomerTransactionDetails" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route
          path="/customer-engagement/manage-group"
          element={
            <DefaultLayout
              children={
                <ErrorBoundary
                  FallbackComponent={RouteErrorFallback}
                >
                  <ProtectedRoute route="CustomerGroup" />
                </ErrorBoundary>
              }
            />
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};
export default Routing;
